import { SectionI } from "@PublicationReader/@types/Publication";
import { useEffect } from "react";

interface BodyProps {
  sections: SectionI[];
}

interface SectionProps {
  section: SectionI;
  headingLevel?: number;
}

const mapSections = (sections: SectionI[], headingLevel = 2) => {
  // Only allow h2 -> h6
  const safeHeadingLevel = Math.min(Math.max(headingLevel, 2), 6);

  return sections.map((section) => {
    return (
      <Section
        section={section}
        headingLevel={safeHeadingLevel}
        key={section.sectionId}
      />
    );
  });
};

const Section = ({ section, headingLevel = 2 }: SectionProps) => {
  const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;

  return (
    <div key={section.sectionId}>
      <HeadingTag id={section.sectionId}>{section.sectionHeading}</HeadingTag>
      <div dangerouslySetInnerHTML={{ __html: section.sectionText }} />
      {section.subSections &&
        section.subSections.length > 0 &&
        mapSections(section.subSections, headingLevel + 1)}
    </div>
  );
};

const Body = ({ sections }: BodyProps) => {

  useEffect(() => {
    const readerBodyElement = document.getElementById('pubr-reader-body');

    const scrollToAnchorAdjustedForHeader = (targetElement: HTMLElement) => {
      const headerOffset = 67;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }

    const scrollToAnchor = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (target.tagName === "A") {
        const anchorElement = target as HTMLAnchorElement;
        const href = anchorElement.href;

        if (href.includes("#")) {
          const id = href.split("#")[1];
          const targetAnchor = document.getElementById(id);

          if (targetAnchor) {
            event.preventDefault();
            scrollToAnchorAdjustedForHeader(targetAnchor);
          }
        }
      }
    };

    if (readerBodyElement) {
      readerBodyElement.addEventListener("click", scrollToAnchor);
      return () => readerBodyElement.removeEventListener("click", scrollToAnchor);
    }
    else {
      return;
    }
  }, []);

  return (
    <div id="pubr-reader-body" className="pubr-reader-body">{mapSections(sections)}</div>
  );
};

export { Body };
